import React from 'react'
import Trolley from './Trolley.svg'
import Bag from './Bag.svg'

const BaggageInfo = props => {
  const {
    isCab,
    info,
    isPWA,
    type
  } = props
  const infoLong = info?.includes('x') || info?.includes('X')
  let infoString
  if (infoLong) {
    const infoArray = info.split(' ')
    infoString = `${infoArray[2]} ${infoArray[3]} ${infoArray[4]}`
  }
  return (
    <div className="flex-column" style={{ paddingTop: isPWA ? '5px' : '' }}>
      {infoLong && info && isCab &&
        <span>{info[0]}{<Bag className="ml-1 mr-1 pt-1" />}{infoString}</span>
      }
      {infoLong && info && !isCab &&
        <span>{info[0]}{<Trolley className="pt-1 ml-1 mr-1" />}{infoString}</span>
      }
      {!infoLong && info &&
        <p style={{ paddingTop: isPWA ? '3px' : '5px' }}>{info}</p>
      }
      {!info &&
        <p>0 kg (Per {type})</p>
      }
    </div>
  )
}

export default BaggageInfo
